var React = require('react');

function Discourse (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.068 4C7.689 4 4 7.518 4 11.86L4.004 20l8.064-.007c4.382 0 7.932-3.654 7.932-7.996C20 7.654 16.45 4 12.068 4zM12 16.571a4.541 4.541 0 0 1-1.943-.432l-2.896.718.817-2.678A4.571 4.571 0 1 1 12 16.572z","fill":"#F9FAFA","fillRule":"evenodd"}));
}

Discourse.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Discourse;

Discourse.default = Discourse;
